import { render, staticRenderFns } from "./AppHeading.vue?vue&type=template&id=631907ae&"
import script from "./AppHeading.vue?vue&type=script&lang=js&"
export * from "./AppHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports